import { render, staticRenderFns } from "./HeroCard.vue?vue&type=template&id=77764665&scoped=true"
import script from "./HeroCard.vue?vue&type=script&lang=js"
export * from "./HeroCard.vue?vue&type=script&lang=js"
import style0 from "./HeroCard.vue?vue&type=style&index=0&id=77764665&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77764665",
  null
  
)

export default component.exports